module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Duplicate-fb7117408ef554197fe271a85dd0541a.svg";